/**
 * @fileoverview added by tsickle
 * Generated from: util/paginated-response.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { baseObject } from './base-object';
import { serializerField, serializer as serializerModel } from './serializers';
/**
 * @record
 */
function PaginatedResponseOpts() { }
if (false) {
    /** @type {?} */
    PaginatedResponseOpts.prototype.json;
    /** @type {?} */
    PaginatedResponseOpts.prototype.requestFn;
    /** @type {?} */
    PaginatedResponseOpts.prototype.serializer;
    /** @type {?} */
    PaginatedResponseOpts.prototype.serializerKwargs;
}
/**
 * @record
 * @template T
 */
function PaginatedResponse() { }
if (false) {
    /** @type {?} */
    PaginatedResponse.prototype.currentPage;
    /** @type {?} */
    PaginatedResponse.prototype.getNext;
    /** @type {?} */
    PaginatedResponse.prototype.getPage;
    /** @type {?} */
    PaginatedResponse.prototype.getPrevious;
    /** @type {?} */
    PaginatedResponse.prototype.hasNext;
    /** @type {?} */
    PaginatedResponse.prototype.numPages;
    /** @type {?} */
    PaginatedResponse.prototype.results;
}
/** @type {?} */
var paginatedResponse = baseObject.extend({
    /**
     * Copy the data from the response, and serialize the results.
     * @param opts.response Object  - Response from the server
     * @param opts.serializer Object} - The serializer to use on results
     */
    construct: /**
     * Copy the data from the response, and serialize the results.
     * @param {?} opts
     * @return {?}
     */
    function (opts) {
        var json = opts.json, requestFn = opts.requestFn, serializer = opts.serializer, serializerKwargs = opts.serializerKwargs;
        this.requestFn = requestFn;
        this.serializer = serializer;
        this.serializerKwargs = Object.assign({}, serializerKwargs, { many: true });
        this.parsePage(json);
    },
    /**
     * Request the given page from the server.
     * Updates the current response in-place.
     * @param n number  - The page number to retrieve
     * @return Promise Will resolve once request is complete.
     */
    getPage: /**
     * Request the given page from the server.
     * Updates the current response in-place.
     * @param {?} n number  - The page number to retrieve
     * @return {?} Promise Will resolve once request is complete.
     */
    function (n) {
        var _this = this;
        if (n < 1 || n > this.numPages) {
            throw new Error("Page " + n + " does not exist");
        }
        this.loading = true;
        return this.requestFn(n).then((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
            Object.assign(_this, response);
            _this.loading = false;
            return _this;
        }));
    },
    getPrevious: /**
     * @return {?}
     */
    function () {
        return this.getPage(this.currentPage - 1);
    },
    getNext: /**
     * @return {?}
     */
    function () {
        return this.getPage(this.currentPage + 1);
    },
    hasNext: /**
     * @return {?}
     */
    function () {
        return this.currentPage < this.numPages;
    },
    remove: /**
     * @param {?} object
     * @return {?}
     */
    function (object) {
        /** @type {?} */
        var index = this.results.indexOf(object);
        if (index !== -1) {
            this.results.splice(index, 1);
        }
    },
    parsePage: /**
     * @param {?} json
     * @return {?}
     */
    function (json) {
        /** @type {?} */
        var pageSerializer = serializerModel.extend({
            fields: {
                results: serializerField.create({
                    serializer: this.serializer,
                    serializerKwargs: this.serializerKwargs
                })
            }
        });
        Object.assign(this, pageSerializer.deserialize(json));
    }
});
export { paginatedResponse };
